import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import ConfirmModal from "../../../Components/Common/ConfirmModal";
import CustomPagination from "../../../Components/Common/CustomePagination";
import {
  addBillInvioce,
  deleteBillInvoice,
  editBillInvoice,
  fetchBillInvoiceList,
  fetchBillInvoicePDFList,
  updateInvoiceStatusThunk,
  updateNote,
} from "../../../slices/SalesInvoiceGST/thunk";
import GenerateBillForm from "../../Forms/Transaction/GenerateBillForm";
import { fetchCustomersList, fetchSessionsList } from "../../../slices/thunks";
import ViewBillModal from "../../../Modals/InvoiceGST/ViewBillModal";
import EditBillForm from "../../Forms/Transaction/EditBillForm";
import NF from "../../../assets/images/file.png";
import { CheckCircle, XCircle } from "react-feather";
import Swal from "sweetalert2";

const SalesInvoiceList = () => {
  const dispatch = useDispatch();

  const [showAddForm, setShowAddForm] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearch, setDebounceSearch] = useState("");

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showBillModal, setShowBillModal] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editBillId, setEditBillId] = useState(null);

  const toggleConfirm = () => setIsConfirmOpen(!isConfirmOpen);
  const toggleBillModal = () => setShowBillModal(!showBillModal);

  const invoiceSelector = createSelector(
    (state) => state,
    (state) => ({
      invoices: state.SalesInvoice.billInvoices,
      loading: state.SalesInvoice.loading,
      error: state.SalesInvoice.error,
      pagination: state.SalesInvoice.pagination,
      customers: state.Customer.customers,
      sessions: state.Session.sessions,
      activeSessions: state.Session.selectedSessionYear,
    }),
  );

  const {
    invoices,
    loading,
    error,
    pagination,
    activeSessions,
    customers,
    sessions,
  } = useSelector(invoiceSelector);

  // When clicking Generate Bill
  const handleOpenAdd = () => {
    dispatch(fetchCustomersList({ isPagination: 0 }));
    // dispatch(fetchSessionsList({ isPagination: 0, isActive: true }));
    setShowAddForm(true);
  };

  const handleAddInvoice = async (invoice) => {
    await dispatch(addBillInvioce(invoice));
    await dispatch(
      fetchBillInvoiceList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
        sessionId: activeSessions?.id,
      }),
    );
  };

  const handleEditBill = (billId) => {
    setEditBillId(billId);
    setShowEditForm(true);
  };

  const handleUpdateInvoice = async (id, updatedBill) => {
    await dispatch(editBillInvoice(id, updatedBill));
    resetSearch();
    await loadInvoices();
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setIsConfirmOpen(true);
  };

  const confirmDelete = async () => {
    await dispatch(deleteBillInvoice(deleteId));
    resetSearch();
    loadInvoices();
  };

  const loadInvoices = async () => {
    await dispatch(
      fetchBillInvoiceList({
        sessionId: activeSessions,
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
        searchTerm: debounceSearch.trim(),
        sessionId: activeSessions?.id,
      }),
    );
  };

  // const handleDownloadPdf = async (id) => {
  //   dispatch(fetchBillInvoicePDFList(id));
  // };

  const handleDownloadPdf = async (id) => {
    const result = await Swal.fire({
      icon: "question",
      title: "Download Bill",
      text: "Do you want to download this bill?",
      showCancelButton: true,
      confirmButtonText: "Yes, Download",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
    });

    if (result.isConfirmed) {
      dispatch(fetchBillInvoicePDFList(id));
    }
  };

  useEffect(() => {
    const t = setTimeout(() => setDebounceSearch(searchTerm), 500);
    return () => clearTimeout(t);
  }, [searchTerm]);

  useEffect(() => {
    loadInvoices();
  }, [pageNo, pageSize, debounceSearch, activeSessions]);

  const getTotalExtraCharges = (invoice) => {
    if (!invoice) return 0;

    const toll = Number(invoice.tollCharges || 0);
    const handling = Number(invoice.handlingCharges || 0);
    const other = Number(invoice.otherCharges || 0);

    return toll + handling + other;
  };

  const handleToggleStatus = async (invoice) => {
    const id = invoice.id;
    const active = !invoice.active;

    // dispatch or API call
    await dispatch(updateInvoiceStatusThunk(id, active));
    resetSearch();
    await loadInvoices();
  };

  const resetSearch = () => {
    setSearchTerm("");
    setDebounceSearch("");
    setPageNo(0);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              {/* <CardHeader>
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h4 className="card-title mb-0">
                    {showAddForm ? "Generate Bill" : "Sales Invoice (GST)"}
                  </h4>

                  {!showAddForm ? (
                    <Button
                      color="primary"
                      className="btn btn-sm"
                      onClick={handleOpenAdd}
                    >
                      <i className="ri-add-line me-1" />
                      Generate Bill
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => setShowAddForm(false)}
                    >
                      <i className="ri-arrow-left-line me-1" />
                      Back to Listing
                    </Button>
                  )}
                </div>
              </CardHeader> */}

              <CardHeader>
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h4 className="card-title mb-0">
                    {/* Conditional Title */}
                    {showAddForm
                      ? "Generate Bill"
                      : showEditForm
                        ? "Edit Invoice"
                        : "Sales Invoice (GST)"}
                  </h4>

                  {/* Conditional Buttons */}
                  {!showAddForm && !showEditForm ? (
                    <Button
                      color="primary"
                      className="btn btn-sm"
                      onClick={handleOpenAdd}
                    >
                      <i className="ri-add-line me-1" />
                      Generate Bill
                    </Button>
                  ) : showEditForm ? (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => {
                        setShowEditForm(false);
                        setEditBillId(null);
                      }}
                    >
                      <i className="ri-arrow-left-line me-1" />
                      Back to Listing
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      className="btn btn-sm"
                      onClick={() => setShowAddForm(false)}
                    >
                      <i className="ri-arrow-left-line me-1" />
                      Back to Listing
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                {showAddForm ? (
                  <GenerateBillForm
                    customersList={customers?.map((c) => ({
                      value: c.id,
                      label: c.name,
                    }))}
                    onSubmit={handleAddInvoice}
                    onCloseForm={() => setShowAddForm(false)}
                  />
                ) : showEditForm ? (
                  <EditBillForm
                    billId={editBillId}
                    onSubmit={handleUpdateInvoice}
                    onCloseForm={() => {
                      setShowEditForm(false);
                      setEditBillId(null);
                    }}
                  />
                ) : (
                  <>
                    {/* Search Bar */}
                    <div className="d-flex justify-content-between mb-3">
                      <div className="search-box w-25">
                        <Input
                          type="text"
                          placeholder="Search invoices..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPageNo(0);
                          }}
                        />
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table className="table table-nowrap align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Sr No</th>
                            <th>Invoice No</th>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Vehicle No</th>
                            <th>SubTotal</th>
                            <th>Total Tax</th>
                            <th>Extra Charges</th>
                            <th>Grand Total</th>
                            <th>Payment Done</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {loading ? (
                            [...Array(pageSize)].map((_, i) => (
                              <tr key={i}>
                                {[...Array(9)].map((__, j) => (
                                  <td key={j}>
                                    <Skeleton height={15} width={80} />
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : error ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-danger text-center"
                              >
                                {error}
                              </td>
                            </tr>
                          ) : invoices?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="9"
                                className="text-center text-muted"
                              >
                                <img
                                  src={NF}
                                  alt="No File"
                                  style={{ width: "500px", marginTop: "10px" }}
                                />
                              </td>
                            </tr>
                          ) : (
                            invoices?.map((invoice, index) => (
                              <tr
                                key={invoice.id}
                                onClick={() => {
                                  setSelectedBill(invoice);
                                  setShowBillModal(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{pageNo * pageSize + index + 1}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{invoice.billDate}</td>

                                <td>
                                  <div
                                    style={{
                                      maxWidth: "100px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    title={invoice.customerName}
                                  >
                                    {invoice.customerName || "-"}
                                  </div>
                                </td>
                                <td>
                                  {[
                                    ...new Set(
                                      invoice?.billInvoiceResponses?.map(
                                        (item) => item?.vehicleNo,
                                      ),
                                    ),
                                  ]
                                    .filter(Boolean)
                                    .join(", ") || "-"}
                                </td>
                                <td>{invoice.subTotal}</td>
                                <td>{invoice.totalGst}</td>
                                <td>{getTotalExtraCharges(invoice)}</td>

                                <td>{invoice.grandTotal}</td>
                                <td
                                  style={{
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleStatus(invoice);
                                  }}
                                >
                                  {invoice.active ? (
                                    <CheckCircle
                                      size={20}
                                      color="#16a34a"
                                      title="Active - Click to deactivate"
                                    />
                                  ) : (
                                    <XCircle
                                      size={20}
                                      color="#dc2626"
                                      title="Inactive - Click to activate"
                                    />
                                  )}
                                </td>

                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-success btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditBill(invoice.id);
                                      }}
                                    >
                                      <i className="ri-edit-2-line"></i>
                                    </button>

                                    <button
                                      className="btn btn-sm btn-outline-danger btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(invoice.id);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadPdf(invoice.id);
                                      }}
                                    >
                                      <i class="ri-printer-line"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <CustomPagination
                      currentPage={pagination?.currentPage}
                      totalPages={pagination?.totalPages}
                      onPageChange={(page) => setPageNo(page)}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      setPageNo={setPageNo}
                    />
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* DELETE CONFIRM */}
      <ConfirmModal
        isOpen={isConfirmOpen}
        toggle={toggleConfirm}
        title="Delete Invoice"
        message="Are you sure you want to delete this invoice?"
        onConfirm={confirmDelete}
      />

      <ViewBillModal
        show={showBillModal}
        toggle={toggleBillModal}
        bill={selectedBill}
      />
    </div>
  );
};

export default SalesInvoiceList;
